import spinner from "assets/gif/spinner-loader.gif"
import { ComponentPropsWithoutRef } from "react"

export const Spinner = (
  props: Omit<ComponentPropsWithoutRef<"img">, "src">
) => <img src={spinner} alt="spinner" {...props} />
